
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.001 19.001a.496.496 0 01-.354-.147l-5-5a.5.5 0 01.708-.707l4.606 4.606L23.112.187a.498.498 0 01.703-.075.497.497 0 01.075.703l-14.5 18a.495.495 0 01-.361.185l-.028.001z"}}),_c('path',{attrs:{"d":"M9.488 23.99a9.46 9.46 0 01-5.035-1.459A9.434 9.434 0 01.25 16.604C-.913 11.5 2.293 6.402 7.396 5.238a9.549 9.549 0 016.327.751.497.497 0 01.226.67.496.496 0 01-.67.226 8.542 8.542 0 00-3.778-.883c-.634 0-1.267.071-1.882.212C3.053 7.255.185 11.816 1.226 16.382a8.432 8.432 0 003.76 5.302 8.46 8.46 0 006.408 1.091 8.436 8.436 0 005.302-3.76 8.436 8.436 0 001.091-6.408.498.498 0 01.489-.612c.233 0 .433.16.485.389a9.427 9.427 0 01-1.219 7.163 9.431 9.431 0 01-5.927 4.203c-.7.159-1.416.24-2.127.24z"}})])
          )
        }
      }
    